/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    CashRegisterModelsListDto,
    CashRegistersModelsListFilterParams,
} from '../api/cashRegisters/cashRegistersClient.typings';
import { Order, PageQueryParams, SortQueryParams } from '../api/apiCommon.typings';
import { CashRegistersActionType, CashRegistersAction } from '../actions/cashRegistersActions';
import { CashRegistersListTableData } from '../../components/RegistryWidgets/CashRegisters/CashRegistersList/CashRegistersListConfig';

export const rowsPerPage = [20, 30, 40];
export const defaultSortingKey: keyof CashRegistersListTableData = 'name';
export const defaultSortingOrder: Order = 'asc';
export const defaultSearchType: keyof CashRegistersListTableData = 'name';
export const defaultPaginationLimit = rowsPerPage[0];
export const defaultAgentFilter: boolean = null;
export const defaultPortableFilter: boolean = null;
const HIDE_SORTING = true;

export interface CashRegistersState {
    cashRegisterModelsList: CashRegisterModelsListDto;
    pageParams: PageQueryParams;
    sortParams: SortQueryParams;
    filterParams: CashRegistersModelsListFilterParams;
    changedFilterParams: CashRegistersModelsListFilterParams;
    isLoading: boolean;
}

const initialState: CashRegistersState = {
    cashRegisterModelsList: {
        count: 0,
        cashRegisterModels: [],
    },
    pageParams: {
        limit: defaultPaginationLimit,
        offset: 0,
    },
    sortParams: {
        sort: HIDE_SORTING ? '' : `${defaultSortingKey},${defaultSortingOrder}`,
    },
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        status: [],
        operatorTaxNumber: [],
        agent: defaultAgentFilter,
        portable: defaultPortableFilter,
    },
    changedFilterParams: null,
    isLoading: false,
};

export function cashRegistersReducer(
    state: CashRegistersState = initialState,
    action: CashRegistersAction,
): CashRegistersState {
    switch (action.type) {
        case CashRegistersActionType.OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case CashRegistersActionType.APPLY_PAGING:
            return {
                ...state,
                isLoading: true,
                pageParams: action.payload,
                changedFilterParams: null,
            };

        case CashRegistersActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,
                pageParams: { ...state.pageParams, offset: 0 },
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case CashRegistersActionType.APPLY_SORTING:
            return {
                ...state,
                isLoading: true,
                sortParams: action.payload,
                changedFilterParams: null,
            };

        case CashRegistersActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case CashRegistersActionType.FETCH_CASH_REGISTERS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cashRegisterModelsList: action.payload.list,
            };

        case CashRegistersActionType.FETCH_CASH_REGISTERS_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                cashRegisterModelsList: {
                    count: 0,
                    cashRegisterModels: [],
                },
            };

        case CashRegistersActionType.DOWNLOAD_EXCEL:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case CashRegistersActionType.DOWNLOAD_EXCEL_SUCCESS:
        case CashRegistersActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case CashRegistersActionType.EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE:
            return {
                ...state,
                cashRegisterModelsList: {
                    count: 0,
                    cashRegisterModels: [],
                },
                changedFilterParams: null,
            };

        default:
            return state;
    }
}
